import { render, staticRenderFns } from "./Ouvidoria.vue?vue&type=template&id=2cee5b6e&"
import script from "./Ouvidoria.vue?vue&type=script&lang=js&"
export * from "./Ouvidoria.vue?vue&type=script&lang=js&"
import style0 from "./Ouvidoria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports